import {
  useQuery,
  useQueries,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { leadService } from "@/services/leadService";

// Hook para buscar todos os leads
export const useLeads = () => {
  return useQuery({
    queryKey: ["leads"],
    queryFn: leadService.getLeads,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};

// Hook para buscar um lead específico
export const useLead = (id: string) => {
  return useQuery({
    queryKey: ["leads", id],
    queryFn: () => leadService.getLeadById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};

// Hook para buscar múltiplos leads por IDs
export const useLeadsByIds = (ids: string[]) => {
  return useQuery({
    queryKey: ["leads", "batch", ids.sort().join(",")],
    queryFn: () => leadService.getLeadsByIds(ids),
    enabled: ids.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};

// Hook para buscar leads individuais (útil quando precisamos de dados específicos)
export const useLeadsQueries = (ids: string[]) => {
  return useQueries({
    queries: ids.map((id) => ({
      queryKey: ["leads", id],
      queryFn: () => leadService.getLeadById(id),
      enabled: !!id,
      staleTime: 5 * 60 * 1000, // 5 minutos
    })),
  });
};

// Hook para criar lead
export const useCreateLead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: leadService.createLead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
  });
};

// Hook para atualizar lead
export const useUpdateLead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: { name: string; email: string; waId: string };
    }) => leadService.updateLead(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
  });
};

// Hook para import de leads
export const useImportLeads = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: FormData) => {
      const response = await fetch("http://localhost:2222/api/leads/import", {
        method: "POST",
        body: formData,
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("Erro ao importar leads");
      }

      return response.json();
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
      // Toast será mostrado pelo componente
    },
    onError: (error) => {
      console.error("Erro no import:", error);
    },
  });
};
